import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const ActivityReportRecord = Record({
  id: 0,
  type: 0,
  status: 0,
  updatedAt: 0,
  documentsCount: 0,
  fundingSearchId: 0,
});

export default class ActivityReportModel extends ActivityReportRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const mapProperties = {
      updatedAt: Hydrator.timestamp2Date,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new ActivityReportModel(hydrated);
  }
}
